import {getLocalOffsetFromUTCOffset} from './getLocalOffsetFromUTCOffset';

/**
 * Returns now date with offset which is equal a range between passed UTC offset and local timezone offset
 */
export function getNowDateWidthOffsetToLocal(timezoneUTCOffset: number) {
	return new Date(Date.now() + getLocalOffsetFromUTCOffset(timezoneUTCOffset));
}
